module.exports = __webpack_public_path__ + "img/database.27743357.svg";